import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { PracticeTestList } from '@/types/practice-test'

export interface ParticipantStoreData {
  // Tab information
  activeTab: string
  classId: string
  moduleId: string
  
  // Exam/Test information
  examTestData: PracticeTestList | null
  
  // Additional data needed for participant-list
  className: string
  moduleName: string
  tutors: string[]
}

interface ParticipantStore {
  data: ParticipantStoreData | null
  hasHydrated: boolean
  
  // Actions
  setParticipantData: (data: ParticipantStoreData) => void
  clearParticipantData: () => void
  updateActiveTab: (tab: string) => void
  updateExamTestData: (examTestData: PracticeTestList) => void
  setHasHydrated: (v: boolean) => void
}

export const useParticipantStore = create<ParticipantStore>()(
  persist(
    (set, _get) => ({
      data: null,
      hasHydrated: false,
      
      setParticipantData: (data) => set({ data }),
      
      clearParticipantData: () => set({ data: null }),
      
      updateActiveTab: (tab) => 
        set((state) => ({
          data: state.data ? { ...state.data, activeTab: tab } : null
        })),
      
      updateExamTestData: (examTestData) =>
        set((state) => ({
          data: state.data ? {
            ...state.data,
            examTestData
          } : null
        })),
      
      setHasHydrated: (v) => set({ hasHydrated: v }),
    }),
    {
      name: 'participant-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ data: state.data }),
      onRehydrateStorage: () => (state) => {
        // set hydrated flag after rehydrate complete
        state?.setHasHydrated(true)
      },
      version: 1,
    }
  )
)
